import React from "react";
import "./Service.css";

const services = [
  {
    icon: "🩺",
    number: "01",
    title: "Medical Coding",
    desc: "Accurate ICD-10, CPT, and HCPCS coding for all specialties with zero-error precision.",
    tag: "ICD-10 · CPT · HCPCS",
  },
  {
    icon: "💳",
    number: "02",
    title: "Medical Billing",
    desc: "End-to-end revenue cycle management from claim submission to final payment collection.",
    tag: "Revenue Cycle",
  },
  {
    icon: "📊",
    number: "03",
    title: "AR Management",
    desc: "Reduce aged receivables and speed up collections with intelligent follow-up workflows.",
    tag: "Collections · Follow-up",
  },
  {
    icon: "🪪",
    number: "04",
    title: "Credentialing",
    desc: "Enroll providers with insurance networks quickly, accurately, and without the headache.",
    tag: "Provider Enrollment",
  },
  {
    icon: "🛡️",
    number: "05",
    title: "Compliance & Audit",
    desc: "Stay HIPAA-compliant and audit-ready with proactive monitoring and documentation.",
    tag: "HIPAA · Audit-Ready",
  },
  {
    icon: "📋",
    number: "06",
    title: "Prior Authorization",
    desc: "Streamlined prior auth processing to eliminate delays and accelerate patient care approvals.",
    tag: "Auth · Approvals",
  },
];

const Service = () => {
  return (
    <div className="Services_pg__wrap">

      {/* Header */}
      <div className="Services_pg__header">
      <h2 className="Services_pg__heading">
          Our <em className="Services_pg__heading-em">Services</em>
        </h2>
        <p className="Services_pg__sub">
          Medical coding &amp; billing solutions built for modern healthcare providers.
        </p>
      </div>

      {/* 3×2 Cards grid */}
      <div className="Services_pg__grid">
        {services.map((s, i) => (
          <div
            key={i}
            className="Services_pg__card"
            style={{ animationDelay: `${i * 0.08}s` }}
          >
            <span className="Services_pg__card-num">{s.number}</span>
            {/* <div className="Services_pg__card-icon">{s.icon}</div> */}
            <h3 className="Services_pg__card-title">{s.title}</h3>
            <p className="Services_pg__card-desc">{s.desc}</p>
            <span className="Services_pg__card-tag">{s.tag}</span>
          </div>
        ))}
      </div>

    </div>
  );
};

export default Service;